var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[(_vm.loading)?_c('v-flex',{attrs:{"text-md-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_c('div',[_c('show',{attrs:{"menu":_vm.selectedMenu}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }